"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributionService = void 0;
class AttributionService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns the attribution status
     * @param fromDate
     * @param toDate
     * @param page
     * @param count
     * @param advertiserId
     * @param attributionMethod
     * @returns AttributionStatusReportResponse
     * @throws ApiError
     */
    attributionStatusReport(fromDate, toDate, page, count, advertiserId, attributionMethod) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/attribution/status',
            query: {
                'page': page,
                'count': count,
                'fromDate': fromDate,
                'toDate': toDate,
                'advertiserId': advertiserId,
                'attributionMethod': attributionMethod,
            },
        });
    }
}
exports.AttributionService = AttributionService;
